(function(){
  if(window.JanineAppointmentReady)return;
  window.JanineAppointmentReady=true;
  function reveal(root){
    var items=root.querySelectorAll('.ja__reveal');
    if(!items.length)return;
    if(!('IntersectionObserver'in window)||window.matchMedia('(prefers-reduced-motion: reduce)').matches){items.forEach(function(el){el.classList.add('is-visible')});return}
    var observer=new IntersectionObserver(function(entries){entries.forEach(function(entry){if(entry.isIntersecting){entry.target.classList.add('is-visible');observer.unobserve(entry.target)}})},{threshold:.12,rootMargin:'0px 0px -8% 0px'});
    items.forEach(function(el){observer.observe(el)});
  }
  function projects(root){
    root.querySelectorAll('[data-ja-projects]').forEach(function(section){
      var track=section.querySelector('[data-ja-track]');
      var prev=section.querySelector('[data-ja-prev]');
      var next=section.querySelector('[data-ja-next]');
      if(!track||!prev||!next)return;
      function step(){var card=track.querySelector('.ja-projects__card');return card?card.getBoundingClientRect().width+parseFloat(getComputedStyle(track).gap||0):track.clientWidth*.8}
      function update(){var mobile=window.matchMedia('(max-width: 809.98px)').matches;prev.hidden=!mobile;next.hidden=!mobile;if(!mobile)return;prev.disabled=track.scrollLeft<4;next.disabled=track.scrollLeft+track.clientWidth>=track.scrollWidth-4}
      prev.addEventListener('click',function(){track.scrollBy({left:-step(),behavior:'smooth'})});
      next.addEventListener('click',function(){track.scrollBy({left:step(),behavior:'smooth'})});
      track.addEventListener('scroll',update,{passive:true});window.addEventListener('resize',update);update();
    });
  }
  function normalizeService(value){
    var service=(value||'').toLowerCase();
    if(service.indexOf('interior design')>-1)return'interior';
    if(service.indexOf('wallpaper')>-1)return'wallpaper';
    if(service.indexOf('upholstery')>-1)return'upholstery';
    if(service.indexOf('curtain')>-1||service.indexOf('quote')>-1)return'curtain';
    if(service.indexOf('furniture')>-1)return'furniture';
    if(service.indexOf('showroom')>-1)return'showroom';
    return'';
  }
  function appointmentForms(root){
    root.querySelectorAll('[data-ja-appointment-form]').forEach(function(form){
      if(form.dataset.jaConditionalReady==='true')return;
      var controller=form.querySelector('[data-ja-service-controller]');
      var conditionalFields=Array.prototype.slice.call(form.querySelectorAll('[data-ja-service-field], [data-ja-service-hide]'));
      var otherController=form.querySelector('[data-ja-other-controller]');
      var otherField=form.querySelector('[data-ja-other-field]');
      form.querySelectorAll('input[type="file"]').forEach(function(input){
        input.addEventListener('change',function(){
          var output=input.closest('.ja-form__field').querySelector('[data-ja-file-name]');
          if(!output)return;
          output.textContent=input.files&&input.files.length?input.files[0].name:output.dataset.jaEmptyText;
        });
      });
      if(otherController&&otherField){
        var otherInput=otherField.querySelector('input, select, textarea');
        function updateOtherField(){
          var active=otherController.value===otherController.dataset.jaOtherTrigger;
          otherField.hidden=!active;
          otherField.setAttribute('aria-hidden',active?'false':'true');
          if(otherInput){
            otherInput.disabled=!active;
            otherInput.required=active&&otherInput.dataset.jaRequired==='true';
            if(!active)otherInput.value='';
          }
        }
        otherController.addEventListener('change',updateOtherField);
        updateOtherField();
      }
      form.dataset.jaConditionalReady='true';
      if(!controller||!conditionalFields.length)return;

      function updateConditionalFields(){
        var activeService=normalizeService(controller.value);
        conditionalFields.forEach(function(field){
          var showService=field.dataset.jaServiceField||'';
          var hideService=field.dataset.jaServiceHide||'';
          var active=(!showService||showService===activeService)&&(!hideService||hideService!==activeService);
          field.hidden=!active;
          field.setAttribute('aria-hidden',active?'false':'true');
          field.querySelectorAll('input, select, textarea').forEach(function(control){
            control.disabled=!active;
            control.required=active&&control.dataset.jaRequired==='true';
          });
        });
      }

      controller.addEventListener('change',updateConditionalFields);
      updateConditionalFields();
    });
  }
  function init(root){reveal(root);projects(root);appointmentForms(root)}
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',function(){init(document)})}else{init(document)}
  document.addEventListener('shopify:section:load',function(event){init(event.target)});
})();
